// extracted by mini-css-extract-plugin
export default {"component":"body-skeleton_component__G5WtJ","fadeIn":"body-skeleton_fadeIn__9hoAs","skeleton":"body-skeleton_skeleton__PkGdT","content-fade":"body-skeleton_content-fade__Y+CLh"};